import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

const BOTTOM_THRESHOLD = 2;

export default class ScrollTabsController extends Controller {
  static targets = [
    'panel',
    'link'
  ];

  initialize() {
    this.visiblePanelIds = new Set();
    this.observer = new IntersectionObserver(
      this.#updateActiveTab.bind(this),
      {
        root: null,
        threshold: 0.3
      }
    );
    this.onScroll = this.#refreshActiveTab.bind(this);
  }

  connect() {
    this.panelTargets.forEach(panel => this.observer.observe(panel));
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnect() {
    this.observer.disconnect();
    window.removeEventListener('scroll', this.onScroll);
  }

  #updateActiveTab(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.visiblePanelIds.add(entry.target.id);
      } else {
        this.visiblePanelIds.delete(entry.target.id);
      }
    });

    this.#refreshActiveTab();
  }

  #refreshActiveTab() {
    const panel = this.#activePanel();
    if (!panel) return;

    const link = this.linkTargets.find(link =>
      link.getAttribute('href') === `#${panel.id}`
    );

    if (link) this.#activateLink(link);
  }

  #activePanel() {
    if (this.#scrolledToBottom()) {
      return this.panelTargets[this.panelTargets.length - 1];
    }

    return this.panelTargets.find(panel =>
      this.visiblePanelIds.has(panel.id)
    );
  }

  #scrolledToBottom() {
    const scrollHeight = document.documentElement.scrollHeight;
    if (scrollHeight <= window.innerHeight) return false;

    return window.innerHeight + window.scrollY >= scrollHeight - BOTTOM_THRESHOLD;
  }

  #activateLink(link) {
    if (link.classList.contains('active')) return;

    this.linkTargets.forEach(link => link.classList.remove('active'));
    link.classList.add('active');
    const tab = new bootstrap.Tab(link);
    tab.show();
  }
}
